export var EAgreementActionTypes = /*#__PURE__*/function (EAgreementActionTypes) {
  EAgreementActionTypes["MarketingSubscriptionAccepted"] = "agreement/marketingSubscriptionAccepted";
  EAgreementActionTypes["LicenceAccepted"] = "agreement/licenceAccepted";
  return EAgreementActionTypes;
}({});